import React, { useEffect, useState } from "react"
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

const RestrictModal = ({ isOpen, toggle, user, onConfirm }) => {
  const [reason, setReason] = useState("")

  useEffect(() => {
    if (isOpen) setReason("")
  }, [isOpen])

  const handleConfirm = () => {
    if (!user) return
    onConfirm({ user_id: user.id, reason: reason.trim() || null })
    toggle()
  }

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag="h4">
        Restringir usuario
      </ModalHeader>
      <ModalBody>
        <p>
          El usuario <strong>{user?.name}</strong> no podrá crear ni editar requisiciones, bienes, áreas,
          facturas ni configuración. Podrá iniciar sesión, consultar información y generar documentos.
        </p>
        <Label for="restriction-reason">Motivo (opcional)</Label>
        <Input
          id="restriction-reason"
          type="textarea"
          maxLength={255}
          value={reason}
          onChange={e => setReason(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>Cancelar</Button>
        <Button color="danger" onClick={handleConfirm} disabled={!user}>Restringir</Button>
      </ModalFooter>
    </Modal>
  )
}

export default RestrictModal
